import React, { useEffect, useState } from "react";
import "./Attendance.css";
import ApiManager from "../../ApiManager/ApiManager";
import { useParams } from "react-router-dom";
import FilterBar from "../../components/FilterBar/FilterBar";
import { useAuth } from "../../components/AuthProvider";
import PERMISSIONS from "../../permissions";
import { ShowButton } from "../../components/RoleBasedComponents";
import { LoadingSpinner } from "../../components/LoadingSpinner/LoadingSpinner";
import { useComponentLoading } from "../../utils/useComponentLoading";
import { toast, ToastContainer } from "react-toastify";

const Attendance = () => {
  const { driverId } = useParams();
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({});
  const [daysInMonth, setDaysInMonth] = useState([]);
  const [attendanceMap, setAttendanceMap] = useState({});
  const [isFromTrip, setIsFromTrip] = useState(false);
  const [initialState, setInitialState] = useState({});
  const [driverName, setDriverName] = useState("");

  const { loadingStates, loadingMessages, withLoading, getMessage, isLoading } =
    useComponentLoading({
      fetchData: false,
      fetchAttendanceByTrip: false,
      markAttendance: false,
    });

  // const toggleAttendance = (day) => {
  //   const states = ["unmarked", "present", "absent"];
  //   const currentState = attendanceMap[day] || "unmarked";
  //   const nextState = states[(states.indexOf(currentState) + 1) % states.length];

  //   setAttendanceMap((prev) => ({
  //     ...prev,
  //     [day]: nextState,
  //   }));
  // };

  const toggleAttendance = (day) => {
    let states = isFromTrip
      ? ["unmarked", "present", "absent"]
      : ["present", "absent"];

    const currentState = attendanceMap[day];

    console.log("Initial State: ", initialState[day]);

    if (!isFromTrip && initialState[day] === "unmarked") {
      states = ["unmarked", "present", "absent"];
    }

    console.log("states: ", states);

    const nextState =
      states[(states.indexOf(currentState) + 1) % states.length];

    setAttendanceMap((prev) => ({
      ...prev,
      [day]: nextState,
    }));
  };

  useEffect(() => {
    withLoading("fetchData", fetchData, "Fetching attendance data...");
  }, [driverId, filters]);

  const fetchData = async () => {
    try {
      const query = new URLSearchParams({
        driverId: driverId,
      });

      const response = await ApiManager.getDriver(query);
      if (!response.ok) throw new Error("Network response was not ok");
      const json = await response.json();
      setData(json);
      setDriverName(`${json.firstName || ""} ${json.lastName || ""}`.trim());

      if (filters.startTime && filters.endTime) {
        const start = new Date(filters.startTime);
        start.setHours(23, 59, 59, 999);
        const end = new Date(filters.endTime);
        end.setHours(23, 59, 59, 999);
        const days = Array.from(
          { length: (end - start) / (1000 * 3600 * 24) + 1 },
          (_, i) => {
            const date = new Date(start);
            date.setDate(start.getDate() + i);
            return Math.floor(date.getTime() / 1000);
          }
        );

        console.log(
          "Setting days:",
          days.map((d) => new Date(d * 1000).toISOString())
        );
        setDaysInMonth(days);

        const attendanceData = await fetchAttendance();
        console.log("Attendance data from fetchAttendance:", attendanceData);

        const newAttendanceMap = {};
        attendanceData.forEach((item) => {
          // Convert dd-mm-yyyy to Unix timestamp
          const [day, month, year] = item.date.split("-");
          const date = new Date(year, month - 1, day);
          date.setHours(23, 59, 59, 999);
          const timestamp = Math.floor(date.getTime() / 1000);

          newAttendanceMap[timestamp] = item.status;
          console.log(
            `Processing date ${item.date} -> ${timestamp} with status ${item.status}`
          );
        });

        console.log(
          "Final attendance map:",
          Object.entries(newAttendanceMap).map(([date, status]) => ({
            date: new Date(date * 1000).toISOString(),
            status,
          }))
        );

        setAttendanceMap(newAttendanceMap);
        setInitialState(newAttendanceMap);
      } else {
        try {
          const now = new Date();
          const start = new Date(now.getFullYear(), now.getMonth(), 1);
          start.setHours(23, 59, 59, 999);

          const end = new Date();
          end.setDate(end.getDate() - 1);
          end.setHours(23, 59, 59, 999);

          const days = Array.from(
            { length: (end - start) / (1000 * 3600 * 24) + 1 },
            (_, i) => {
              const date = new Date(start);
              date.setDate(start.getDate() + i);
              return Math.floor(date.getTime() / 1000);
            }
          );

          console.log(
            "Setting days:",
            days.map((d) => new Date(d * 1000).toISOString())
          );
          setDaysInMonth(days);

          const query = new URLSearchParams({
            driver_id: driverId,
            from: Math.floor(start.getTime() / 1000),
            to: Math.floor(end.getTime() / 1000),
          });

          const response = await ApiManager.getAttendanceDriver(query);
          if (!response.ok) throw new Error("Network response was not ok");
          const json = await response.json();
          console.log("Attendance data from getAttendanceDriver:", json);

          const newAttendanceMap = {};
          json.forEach((item) => {
            // Convert dd-mm-yyyy to Unix timestamp
            const [day, month, year] = item.date.split("-");
            const date = new Date(year, month - 1, day);
            date.setHours(23, 59, 59, 999);
            const timestamp = Math.floor(date.getTime() / 1000);

            newAttendanceMap[timestamp] = item.status;
            console.log(
              `Processing date ${item.date} -> ${timestamp} with status ${item.status}`
            );
          });

          console.log(
            "Final attendance map:",
            Object.entries(newAttendanceMap).map(([date, status]) => ({
              date: new Date(date * 1000).toISOString(),
              status,
            }))
          );

          setAttendanceMap(newAttendanceMap);
          setInitialState(newAttendanceMap);
        } catch (error) {
          console.log("error", error);
          throw error;
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const apiFunctions = {
    attendance: ApiManager.attendance,
  };

  const handleFilterChange = (filterValues) => {
    setFilters(filterValues);
  };

  const fetchAttendanceByTrip = async () => {
    try {
      await withLoading(
        "fetchAttendanceByTrip",
        async () => {
          const now = new Date();
          let start = new Date(now.getFullYear(), now.getMonth(), 1);
          start.setHours(23, 59, 59, 999);

          let end = new Date();
          end.setDate(end.getDate() - 1);
          end.setHours(23, 59, 59, 999);

          if (filters.startTime && filters.endTime) {
            start = new Date(filters.startTime);
            start.setHours(23, 59, 59, 999);
            end = new Date(filters.endTime);
            end.setHours(23, 59, 59, 999);
          }

          // First set the days
          const days = Array.from(
            { length: (end - start) / (1000 * 3600 * 24) + 1 },
            (_, i) => {
              const date = new Date(start);
              date.setDate(start.getDate() + i);
              date.setHours(23, 59, 59, 999);
              return Math.floor(date.getTime() / 1000);
            }
          );
          console.log(
            "Setting days:",
            days.map((d) => new Date(d * 1000).toISOString())
          );

          const query = new URLSearchParams({
            driver_id: driverId,
            from: Math.floor(start.getTime() / 1000),
            to: Math.floor(end.getTime() / 1000),
          });

          console.log(
            "Fetching attendance by trip with query:",
            query.toString()
          );
          const response = await ApiManager.getAttendanceByTrip(query);
          if (!response.ok) throw new Error("Network response was not ok");
          const json = await response.json();
          console.log("Raw attendance data from API:", json);

          setIsFromTrip(true);

          const newAttendanceMap = {};
          json.forEach((item) => {
            // Convert dd-mm-yyyy to Unix timestamp
            const [day, month, year] = item.date.split("-");
            const date = new Date(year, month - 1, day);
            date.setHours(23, 59, 59, 999);
            const timestamp = Math.floor(date.getTime() / 1000);

            newAttendanceMap[timestamp] = item.status;
            console.log(
              `Processing date ${item.date} -> ${timestamp} with status ${item.status}`
            );
          });

          console.log(
            "Final attendance map:",
            Object.entries(newAttendanceMap).map(([date, status]) => ({
              date: new Date(date * 1000).toISOString(),
              status,
            }))
          );

          setDaysInMonth(days);
          setAttendanceMap(newAttendanceMap);
          setInitialState(newAttendanceMap);
          toast.success("Attendance fetched successfully");
        },
        "Fetching attendance by trip..."
      );
    } catch (error) {
      console.log("error", error);
      throw error;
    }
  };

  const fetchAttendance = async () => {
    try {
      return await withLoading(
        "fetchAttendance",
        async () => {
          const start = new Date(filters.startTime);
          start.setHours(23, 59, 59, 999);
          const end = new Date(filters.endTime);
          end.setHours(23, 59, 59, 999);

          const query = new URLSearchParams({
            driver_id: driverId,
            from: filters.startTime
              ? Math.floor(start.getTime() / 1000)
              : undefined,
            to: filters.endTime ? Math.floor(end.getTime() / 1000) : undefined,
          });

          const response = await ApiManager.getAttendanceDriver(query);
          if (!response.ok) throw new Error("Network response was not ok");
          const json = await response.json();

          setIsFromTrip(false);
          return json;
          toast.success("Attendance fetched successfully");
        },
        "Fetching attendance data...",
        "custom-button loading"
      );
    } catch (error) {
      console.log("error", error);
      throw error;
    }
  };

  const markAttendance = async () => {
    try {
      await withLoading(
        "markAttendance",
        async () => {
          const requestData = Object.entries(attendanceMap).map(
            ([timestamp, status]) => {
              const date = new Date(timestamp * 1000);
              const day = String(date.getDate()).padStart(2, "0");
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const year = date.getFullYear();
              const dateString = `${day}-${month}-${year}`;

              return {
                driver_id: Number(driverId),
                date: dateString,
                status,
              };
            }
          );

          console.log("Sending attendance data:", requestData);

          const query = new URLSearchParams({
            driver_id: driverId,
          });
          const response = await ApiManager.markAttendance(query, requestData);
          if (!response.ok) throw new Error("Network response was not ok");
          toast.success("Attendance marked successfully");
        },
        "Marking attendance..."
      );
    } catch (error) {
      console.log("error", error);
    }
  };

  const getMonthName = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleString("default", {
      month: "long",
      year: "numeric",
    });
  };

  const groupDaysByMonth = (days) => {
    const months = {};
    days.forEach((day) => {
      const date = new Date(day * 1000);
      const monthKey = `${date.getFullYear()}-${date.getMonth()}`;
      if (!months[monthKey]) {
        months[monthKey] = {
          name: getMonthName(day),
          days: [],
        };
      }
      months[monthKey].days.push(day);
    });
    return months;
  };

  const getFirstDayOfMonth = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  };

  const renderCalendar = (monthDays) => {
    const firstDay = getFirstDayOfMonth(monthDays[0]);
    const days = [...Array(firstDay).fill(null), ...monthDays];

    console.log("Rendering calendar with days:", days);
    console.log("Current attendance map:", attendanceMap);
    console.log("Initial state:", initialState);

    return (
      <div className="calendar-grid">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
          <div key={day} className="calendar-header">
            {day}
          </div>
        ))}
        {days.map((day, index) => {
          const status = day ? attendanceMap[day] || "unmarked" : "";
          console.log(
            `Day ${day}, Status: ${status}, Raw attendance data:`,
            attendanceMap[day]
          );
          return (
            <div
              key={index}
              className={`calendar-day ${!day ? "empty" : ""} ${status}`}
              onClick={() => day && toggleAttendance(day)}
            >
              {day && (
                <>
                  <div className="calendar-day-number">
                    {new Date(day * 1000).getDate()}
                  </div>
                  <div className="attendance-status">
                    {status === "present"
                      ? "P"
                      : status === "absent"
                      ? "A"
                      : "U"}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  if (loadingStates.fetchData) {
    return (
      <div className="attendance-container">
        <LoadingSpinner
          size="large"
          message={getMessage("fetchData") || "Loading attendance data..."}
        />
      </div>
    );
  }

  return (
    <div className="attendance-container">
      <ToastContainer />
      <div className="attendance-header">
        <h2>Attendance</h2>
        {driverName && <h3 className="driver-name">Driver: {driverName}</h3>}
      </div>
      <div className="controls-container">
        <FilterBar
          filterOptions={[{ value: "date", label: "Date" }]}
          onFilterChange={handleFilterChange}
          apiFunctions={apiFunctions}
        />
        <div className="attendance-actions">
          <ShowButton
            permission={PERMISSIONS.VENDOR_DRIVER_ATTENDANCE_BY_TRIPS_READ}
          >
            <button
              className={`custom-button ${
                isLoading("fetchAttendanceByTrip") ? "loading" : ""
              }`}
              onClick={fetchAttendanceByTrip}
              disabled={isLoading("fetchAttendanceByTrip")}
            >
              {isLoading("fetchAttendanceByTrip") ? (
                <LoadingSpinner size="xs" inline={true} message="Fetching..." />
              ) : (
                "Fetch Attendance By Trip"
              )}
            </button>
          </ShowButton>
        </div>
      </div>

      <div className="calendar-section">
        {Object.entries(groupDaysByMonth(daysInMonth)).map(
          ([monthKey, monthData]) => (
            <div key={monthKey} className="calendar-month">
              <div className="month-header">{monthData.name}</div>
              {renderCalendar(monthData.days)}
            </div>
          )
        )}
      </div>
      <div style={{ display: "flex", justifyContent: "right", marginTop: "20px" }}>
      <ShowButton permission={PERMISSIONS.VENDOR_ATTENDANCE_UPDATE}>
        <button
          className={`custom-button ${
            isLoading("markAttendance") ? "loading" : ""
          }`}
          onClick={markAttendance}
          disabled={isLoading("markAttendance")}
        >
          {isLoading("markAttendance") ? (
            <LoadingSpinner size="xs" inline={true} message="Saving..." />
          ) : (
            "Mark Attendance"
          )}
        </button>
      </ShowButton>
      </div>
    </div>
  );
};

export default Attendance;
